




























import { Component, Prop, Vue } from 'vue-property-decorator'
import SearchConverter from '@/components/party/search/SearchConverter'
import PlaylistResponse from '@/types/PlaylistResponse'

  @Component
export default class SubSearchDisplayer extends Vue {
    @Prop() playlist!: PlaylistResponse
    @Prop() selectPlaylist!: Function
}
